import { FC, ReactNode } from 'react';
import './Field.css';
import { Field as FieldDefinition } from '@/types/core/Field';
import Stack from '../Stack/Stack';
import Text from '../Text/Text';
import Tooltip from '../Tooltip/Tooltip';

interface FieldProps {
  field: FieldDefinition;
  children: ReactNode;
}

const Field: FC<FieldProps> = ({ field, children }) => {
  const { label, description, tooltip, className } = field;

  return (
    <Stack className={`field ${className}`}>
      <Stack direction="vertical" gap={2}>
        <Text className="field__label">
          {label}
        </Text>
        {tooltip && (
          <Tooltip content={tooltip} />
        )}
      </Stack>
      {description && (
        <Text className="field__description">{description}</Text>
      )} 
      <Stack className="field__content">{children}</Stack>
    </Stack>
  );
};

export default Field; 